import { WidgetDataSource } from '../../../../../../../models';
import {
  Widget,
  WidgetGroup,
  Comparison,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class NmotPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    selectedPoints.sort((p1, p2) => p1.category - p2.category);

    const payload = super.assemblePayloadFromSelection(
      selectedPoints.flatMap((p) => p),
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    for (let pointIdx = 0; pointIdx < selectedPoints.length; pointIdx++) {
      let pointGroup = selectedPoints[pointIdx];
      if (!Array.isArray(selectedPoints[pointIdx])) {
        pointGroup = [selectedPoints[pointIdx]];
      }

      for (let comparisonIdx = 0; comparisonIdx < pointGroup.length; comparisonIdx++) {
        const point = pointGroup[comparisonIdx];
        const fieldIdx = point.series.chart.series.indexOf(point.series);
        const field =
          widget.payload.numericMetadataFields![fieldIdx] ??
          widget.payload.numericMetadataFields![0];
        const bucket = payload.buckets[pointIdx * pointGroup.length + comparisonIdx];

        bucket.analytic_item_type = FieldService.getFieldLongName(field.fieldId);
        bucket.analytic_item_value = point.y;

        if (field.scoring === 'nps') {
          bucket.best_rating_value = field.max;
          bucket.worst_rating_value = field.min;
          bucket.metric_calculation = 'rating';
          bucket.rating_field = bucket.analytic_item_type;
          bucket.aggregate_rating_score = bucket.analytic_item_value;
          bucket.rating_score_high = 100;
          bucket.rating_score_low = -100;
        }

        if (field.scoring === 'top' || field.scoring === 'bottom') {
          bucket.rating_score_high = 100;
          bucket.rating_score_low = 0;
        }
      }
    }

    return payload;
  }

  protected override fillWidgetQueryOptionsForPoint(widgetQueryOptions: any, point: any): void {
    super.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);

    widgetQueryOptions.widgetContextMenu.category = point.category;
    widgetQueryOptions.widgetContextMenu.series = point.series;
    widgetQueryOptions.widgetContextMenu.index = point.index;

    widgetQueryOptions.filters.metadata.and.push({
      analyticItem: `metadata.${point.series.options.custom.fieldId}`,
      value: '_exists_',
    });
  }
}
